import React, { useState } from 'react';
import { Plus, Search } from 'lucide-react';

const Enrollments = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const enrollments = [
    { id: 1, student: 'Emma Johnson', class: 'Ballet Beginners', startDate: '2024-01-15', status: 'active', payment: 'paid' },
    { id: 2, student: 'Liam Johnson', class: 'Gymnastics Level 1', startDate: '2024-01-15', status: 'active', payment: 'paid' },
    { id: 3, student: 'Sophia Williams', class: 'Art Club', startDate: '2024-02-01', status: 'active', payment: 'pending' },
    { id: 4, student: 'Noah Brown', class: 'Ballet Beginners', startDate: '2023-09-01', status: 'inactive', payment: 'paid' },
  ];

  const filteredEnrollments = enrollments.filter(e =>
    e.student.toLowerCase().includes(searchTerm.toLowerCase()) ||
    e.class.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="animate-fade-in">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Enrollments</h1>
          <p className="text-gray-500 mt-1">Manage student enrollments in classes.</p>
        </div>
        <button className="mt-4 sm:mt-0 btn-primary flex items-center space-x-2">
          <Plus size={20} />
          <span>New Enrollment</span>
        </button>
      </div>

      {/* Search */}
      <div className="mb-6">
        <div className="relative max-w-md">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
          <input
            type="text"
            placeholder="Search enrollments..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="form-input pl-12"
          />
        </div>
      </div>

      {/* Enrollments Table */}
      <div className="bg-white rounded-xl shadow-sm border border-purple-100 overflow-hidden">
        <div className="overflow-x-auto -mx-6 px-6">
          <table className="w-full min-w-[600px]">
          <thead className="bg-purple-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-purple-700 uppercase">Student</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-purple-700 uppercase">Class</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-purple-700 uppercase">Start Date</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-purple-700 uppercase">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-purple-700 uppercase">Payment</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-purple-50">
            {filteredEnrollments.map((enrollment) => (
              <tr key={enrollment.id} className="hover:bg-purple-50/50">
                <td className="px-6 py-4 font-medium text-gray-900">{enrollment.student}</td>
                <td className="px-6 py-4 text-gray-500">{enrollment.class}</td>
                <td className="px-6 py-4 text-gray-500">{enrollment.startDate}</td>
                <td className="px-6 py-4">
                  <span className={`badge ${enrollment.status === 'active' ? 'badge-success' : 'badge-danger'}`}>
                    {enrollment.status}
                  </span>
                </td>
                <td className="px-6 py-4">
                  <span className={`badge ${enrollment.payment === 'paid' ? 'badge-success' : 'badge-warning'}`}>
                    {enrollment.payment}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
};

export default Enrollments;
